export const getEnv = ()=>{
  // dev","pre","prod" 匹配不同环境
  const env = sessionStorage.getItem('env')|| 'dev' //默认给测试环境
  switch(env){
    case 'dev'://测试环境
      return process.env.VUE_APP_BASE_API
    case 'pre'://预发布
      return 'https://xxddzpre.boyaa.com:8080/v1'
    case 'prod'://正式服
    return 'https://xxddz01.ifere.com:8080/v1'
  }       
}